var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsernameInput(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.666 5C13.503 7.203 11.833 9 10 9S6.494 7.203 6.333 5C6.167 2.708 7.792 1 10 1c2.208 0 3.833 1.75 3.666 4z",
    stroke: "#67696D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.666c-3.625 0-7.304 2-7.985 5.775-.082.455.176.892.652.892h14.666c.477 0 .734-.437.652-.892-.681-3.775-4.36-5.775-7.985-5.775z",
    stroke: "#67696D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })));
}

export default SvgUsernameInput;